/**
 * Add to wisth list button and indicator
 */
class FavButton extends HTMLElement {
  constructor() {
    super();

    this.fav = {
      id: this.dataset.productId,
      handle: this.dataset.productHandle,
    };

    this.isFavProduct();

    this.addEventListener("click", this.toggleFav.bind(this));
  }

  isFavProduct() {
    const favsList = this.getFavList();

    if (!favsList.some((product) => product.id === this.fav.id)) return false;

    this.classList.add("is-fav");
    return true;
  }

  getFavList() {
    const storeFavList =
      JSON.parse(window.localStorage.getItem("favsList_v1")) || [];
    let favList = [];

    if (storeFavList.length > 0) {
      favList = storeFavList;
    } else {
      window.localStorage.setItem("favsList_v1", JSON.stringify([]));
    }

    return favList;
  }

  toggleFav(event) {
    const favsList = this.getFavList();
    const isFavProduct = favsList.some((product) => product.id === this.fav.id);

    if (!isFavProduct) {
      favsList.push(this.fav);
      window.localStorage.setItem("favsList_v1", JSON.stringify(favsList));
      this.classList.add("is-fav");
    } else {
      const newFavsList = favsList.filter(
        (product) => product.id != this.fav.id
      );
      window.localStorage.setItem("favsList_v1", JSON.stringify(newFavsList));
      this.classList.remove("is-fav");
      this.isFavProduct = true;
    }

    const customEvent = new CustomEvent("updateWishlist", {
      detail: { wishlist: this.getFavList() },
    });

    document.dispatchEvent(customEvent);
  }
}

customElements.define("fav-button", FavButton);

/**
 * Wishlist Products list
 */
class WishListProducts extends HTMLElement {
  constructor() {
    super();

    this.emptyWishlist = document.querySelector("#wishlist-empty");

    this.renderWishList();
    this.renderCounter();

    document.addEventListener("updateWishlist", () => {
      this.resetWishListContent();
      this.renderCounter();
      this.renderWishList();
    });
  }

  getWishList() {
    const storeFavList =
      JSON.parse(window.localStorage.getItem("favsList_v1")) || [];
    let favList = [];

    if (storeFavList.length > 0) {
      favList = storeFavList;
    } else {
      window.localStorage.setItem("favsList_v1", JSON.stringify([]));
    }

    return favList;
  }

  renderCounter() {
    const counter = this.getWishList().length;

    document
      .querySelectorAll("favs-counter")
      .forEach((item) => (item.textContent = counter));
  }

  renderWishList() {
    if (this.getWishList().length > 0) {
      this.getWishList().map(async (product) => {
        await fetch(`/products/${product.handle}?view=card`)
          .then((res) => res.text())
          .then((res) => {
            const text = res;
            const parser = new DOMParser();
            const htmlDocument = parser.parseFromString(text, "text/html");
            const productCard =
              htmlDocument.documentElement.querySelector(".card-wrapper");
            if (productCard) {
              this.append(productCard);
            }
          })
          .catch((err) =>
            console.error(
              `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
              err
            )
          );

        this.emptyWishlist.classList.add("hidden");
      });
    } else {
      this.emptyWishlist.classList.remove("hidden");
    }
  }

  resetWishListContent() {
    document
      .querySelectorAll("wishlist-products .card-wrapper")
      .forEach((card) => {
        card.remove();
      });
  }
}

customElements.define("wishlist-products", WishListProducts);
